// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState, useCallback, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { toggleModal, toggleSecondModalClose } from '../../storage/actions/modalsActions';
import { setCurrentApplicants, setCurrentWorkOrder } from '../../storage/actions/workOrdersActions';
import Offer from '../../components/layout/Offer';
import SearchContractorCard from '../../components/layout/contractorCards/SearchContractorCard';
import CertificatesList from '../../components/layout/certificates/CertificatesList';
import Notification from '../../components/notification';
import { orderCertifications } from '../../utils/certificatesOrdering';

const FindContractor = ({
  setCurrentApplicants,
  setCurrentWorkOrder,
  toggleModal,
  mainContainer,
  profile,
  toggleSecondModalClose,
}) => {
  const [contractors, setContractors] = useState([]);
  const [certificates, setCertificates] = useState([]);
  const [selectedCertificates, setSelectedCertificates] = useState(new Set());
  const [searchValue, setSearchValue] = useState({});
  const [userGroup, setUserGroup] = useState(false);
  const [userWorkedBefore, setUserWorkedBefore] = useState(false);
  const [blockedUser, setBlockedUser] = useState(false);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    fetchCertificates();
    setCurrentWorkOrder();

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    fetchContractors(searchValue);
  }, [searchValue]);

  const fetchContractors = useCallback(({ range, search, search_zip: searchZip }) => {
    const searchField = search ? `"${search.replaceAll(' ', '" "')}"` : '';
    toggleModal(true, 'loader', true);
    axios.get('/api/users/contractors', {
      params: {
        range,
        search: searchField,
        zipcode: searchZip,
        userGroup,
        userWorkedBefore,
        blockedUser,
        certificates: [...selectedCertificates].toString(),
      },
    })
      .then(res => {
        if (!isMountedRef.current) return;
        setContractors(res.data.contractors || []);
        toggleSecondModalClose('loader', true);
      }).catch(error => {
        if (!isMountedRef.current) return;
        toggleSecondModalClose('loader', true);
        console.error('error', error);
        Notification('error', {
          message: error.response?.data.message || error.message,
        });
      });
  }, [selectedCertificates, userGroup, userWorkedBefore, blockedUser]);


  const fetchCertificates = () => {
    axios.get('/api/certificates')
      .then(res => {
        if (!isMountedRef.current) return;
        const certifications = orderCertifications(res.data.certificates || [])
        setCertificates(certifications);
      }).catch(error => {
        if (!isMountedRef.current) return;
        Notification('error', {
          message: error.response?.data.message || error.message,
        });
      });
  };

  const openContractorDetails = contractor => {
    toggleModal(true, 'contractorDetailsModal', false, { contractorId: contractor.userId });
  };

  const showBlockModalForCurrentContractor = contractor => {
    toggleModal(true, 'blockModal', false, { contractorId: contractor.userId });
  };

  const openContractorInviteSelectWorkOrder = contractor => {
    setCurrentApplicants({ contractor_details: contractor });
    toggleModal(true, 'contractorInviteSelectWorkOrder');
  };

  const handlerSearchContractors = newSearchValue => {
    setSearchValue(newSearchValue);
  };

  const handlerCertificatesCheckboxChange = ({ target }) => {
    const newSet = new Set([...selectedCertificates]);
    const command = target.checked ? 'add' : 'delete';
    newSet[command](target.value);
    setSelectedCertificates(newSet);
  };

  const checkGroup = ({ target }) => {
    setUserGroup(target.checked)
  }
  const checkWorkedWithBefore = ({ target }) => {
    setUserWorkedBefore(target.checked)
  }
  const checkBlockedUser = ({ target }) => {
    setBlockedUser(target.checked)
  }

  return (
    <div className="subpage-wrap find-contractor-page">

      <Offer
        getSearched={handlerSearchContractors}
        hideControlButton
        showInputRange
        defaultRange={NaN}
      />
      <div className="find-contractor-filters">
        <CertificatesList
          certificates={certificates}
          handlerCheck={handlerCertificatesCheckboxChange}
          checkGroup={checkGroup}
          checkWorkedWithBefore={checkWorkedWithBefore}
          checkBlockedUser={checkBlockedUser}
          blockedUser={blockedUser}
          userGroup={userGroup}
          userWorkedBefore={userWorkedBefore}
        />
      </div>
      <div className="work-orders-list find-contractor-results">
        {
          contractors.map((contractor) => (
            <SearchContractorCard
              key={contractor._id}
              contractor={contractor}
              inviteContractor={openContractorInviteSelectWorkOrder}
              openInfo={openContractorDetails}
              block={profile?.company?.blocked_users?.includes(contractor.userId)}
              showBlockModalForCurrentContractor={showBlockModalForCurrentContractor}
            />
          ))
        }
       
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  toggleModal,
  setCurrentApplicants,
  setCurrentWorkOrder,
  toggleSecondModalClose,
};

const mapStateToProps = state => ({
  auth: state.auth,
  profile: state.profile,
  isReload: state.applicationState.isReload,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FindContractor);
